<div class="order-markers-common-view">
  <div class="row justify-content-around">
    <ng-container *ngFor="let item of items">
      <ng-container *ngIf="item.value">
        <div class="col">
          <div class="item flex align-items-center">
            <div class="item__icon">
              <mat-icon [svgIcon]="item.config.icon"></mat-icon>
            </div>
            <div class="item__description ms-3">
              <strong class="item__header">{{ item.config.header }}</strong>
              <div class="item__value">
                <span>{{ item.viewValue }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>